/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex, Text } from '@radix-ui/themes';

import { colorAt } from 'solis/theme/palette';


export default ({ entry, highlight }) =>
{
  const color = highlight ? colorAt(entry.theme) : 'gray';

  const weight = highlight ? 'medium' : 'regular';

  return (
    <Flex justify = 'between' gap = '3'>
      <Text size = '1' color = {color} weight = {weight}>{entry.rank + ' · ' + entry.name}</Text>
      <Text size = '1' color = {color} weight = {weight}>{entry.value}</Text>
    </Flex>
  );
};
